export default class ArticleCategoriesSerializer {
    static unserialize(response) {
        return response.map(c => { return {value: c.id, label: c.name, description: c.description} });
    }
}


// WEBPACK FOOTER //
// ./web/src/services/ArticleCategoriesSerializer.js